class SliderGalleryComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.sliderFirstItemNode = this.slider.querySelector('.product__media-item');
    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.isMobile = window.matchMedia('(max-width: 749px)');
    this.volumeModelBtn = this.querySelector(".product__media-icon-3d");
    this.volumeModelIndex = parseInt(this.getAttribute("volume-model-index"));
    if (this.volumeModelBtn && this.isMobile.matches) {
      this.volumeModelBtn.addEventListener("click", this.openVolumeModel.bind(this));
    }
  }

  openVolumeModel() {
    if (this.volumeModelIndex) {
      const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.volumeModelIndex + 1 - this.currentPage);
      this.slider.scrollTo({
        left: slideScrollPosition,
      });
    }
    this.update();
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);

    if (this.volumeModelBtn && this.isMobile.matches) {
      if (this.volumeModelIndex === this.currentPage - 1) {
        this.volumeModelBtn.classList.add("visibility-hidden");
      } else {
        this.volumeModelBtn.classList.remove("visibility-hidden");
      }
    }
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slider-gallery-component', SliderGalleryComponent);

class ProductTabs extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      tabButtons: ".product-tabs__tab-button",
      heading: ".product-tabs__heading",
      activeTabButton: "product-tabs__tab-button--active",
      oneHalfTabButton: "product-tabs__tab-button--one-half",
      cursorDefault: "cursor-default",
      opened: "opened",
      visuallyHidden: "visually-hidden",
      hidden: "hidden",
      mainContent: ".tab-content__main-content"
    }
    this.$mobileMediaQuery = window.matchMedia("(max-width: 749px)");
  }

  connectedCallback() {
    this.tabButtons = this.querySelectorAll(`${this.selectors.tabButtons}`);
    this.heading = this.querySelector(`${this.selectors.heading}`);
    this.tabButtons?.forEach((button) => {
      if (this.tabButtons.length === 1) {
        button.classList.add(this.selectors.oneHalfTabButton);
        button.classList.add(this.selectors.cursorDefault);
      }
      button.addEventListener("click", this.handleTabButtonClick.bind(this));
    });
  }

  handleTabButtonClick(event) {
    const target = event.target;
    this.tabButtons.forEach((button) => {
      const mainContent = button.closest(this.selectors.mainContent);
      if (button === target) {
        const isOpen = mainContent.hasAttribute(this.selectors.opened);
        if (isOpen) {
          if (this.$mobileMediaQuery.matches) {
            mainContent.removeAttribute(this.selectors.opened);
            button.classList.remove(this.selectors.activeTabButton);
          }
          // On desktop, clicking the already-active tab keeps it open.
        } else {
          button.classList.add(this.selectors.activeTabButton);
          mainContent.setAttribute(this.selectors.opened, true);
          this.$mobileMediaQuery.matches && button.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      } else {
        button.classList.remove(this.selectors.activeTabButton);
        if (mainContent.hasAttribute(this.selectors.opened)) {
          mainContent.removeAttribute(this.selectors.opened);
        }
      }
    });
  }
}

customElements.define('product-tabs', ProductTabs);

window.addEventListener('pageshow', (event) => {
	if (event.persisted) {
		window.location.reload();
	}
});
